// extracted by mini-css-extract-plugin
export default {"commentRuleRow":"CommentRulesSection_commentRuleRow__ixh78","commentRuleText":"CommentRulesSection_commentRuleText__LsV5j"};